import React, { FC } from 'react';
import Rate from '../../../../../presentational/financeElements/rate/Rate';
import { RateTypes } from '../../../../../../enum/RateTypes';
import { useSelector } from 'react-redux';
import currentDealSelectors from '../../../../../../store/selectors/currentDealSelectors';
import useScrollToSection from '../../../../../../react/navigation/useScrollToSection';
import IndicativeNumber from '../../../../../../../common/components/indicativeNumber/IndicativeNumber';
import Translation from '../../../../../../../common/components/translation/Translation';

const ComparisonRateContainer: FC = () => {
  const comparisonRate: number = useSelector(currentDealSelectors.getFinanceQuoteComparisonRate);
  const { scrollToDisclaimer } = useScrollToSection();

  if (comparisonRate === 0) {
    return null;
  }

  return (
    <Rate
      labelId={RateTypes.COMPARISON_RATE}
      value={<Translation values={{ value: comparisonRate ?? 0 }} id="spc.customise.footer.finance.perAnnumValue" />}
      indicativeNumber={
        <IndicativeNumber
          dataTest="comparisonRate"
          displayNumber={<Translation id="spc.customise.disclaimer.comparisonRate.indicator" />}
          onClick={scrollToDisclaimer}
        />
      }
    />
  );
};

export default ComparisonRateContainer;
